function handleTextButtonClick() {
  const phoneNumber = '+918879412354'; // Replace with the actual phone number in international format
  const message = encodeURIComponent('Hi there! I’ve got a few questions about this product before making a purchase. Could you help me with more details?'); // Customize your message
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;

  window.location.href = whatsappLink;
}